import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App/App';
import './Assets/style.css';

const container = document.getElementById('app');

if (container) {
    const root = createRoot(container);
    
    try {
        root.render(<App />);
    } catch (error) {
        console.error('Error rendering App component:', error);
        container.innerHTML = '<div style="color: red; padding: 20px;">Error loading React app: ' + error.message + '</div>';
    }
} else {
    console.error('No container found with id="app"');
}

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        // Add cache version to service worker URL to force update
        const swVersion = 'v2.3';
        navigator.serviceWorker.register(`/service-worker.js?v=${swVersion}`, {
            updateViaCache: 'none' // Always check for updates, don't use cached service worker
        })
            .then((registration) => {
                console.log('Service Worker registered successfully:', registration.scope);
                
                // Check for updates immediately and periodically
                registration.update();
                
                // Check for updates every 30 seconds
                setInterval(() => {
                    registration.update();
                }, 30000);
                
                // Listen for service worker updates
                registration.addEventListener('updatefound', () => {
                    console.log('New service worker found, installing...');
                    const newWorker = registration.installing;
                    
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                // New service worker is ready, prompt user to refresh
                                console.log('New service worker installed, prompting for refresh');
                                if (window.confirm('A new version is available. Refresh now to get the latest updates?')) {
                                    window.location.reload();
                                }
                            }
                        });
                    }
                });
                
                // Listen for messages from service worker
                navigator.serviceWorker.addEventListener('message', (event) => {
                    if (event.data && event.data.type === 'SW_UPDATED') {
                        console.log('Service worker message:', event.data.message);
                        if (window.confirm(event.data.message + ' Refresh now?')) {
                            window.location.reload();
                        }
                    }
                });
            })
            .catch((error) => {
                console.log('Service Worker registration failed:', error);
            });
        
        // Listen for controller changes (when a new service worker takes control)
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            console.log('Service worker controller changed, reloading page...');
            window.location.reload();
        });
    });
}

// Handle PWA install prompt - store globally for App component to access
window.deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later
    window.deferredPrompt = e;
    console.log('PWA install prompt available');
    
    // Dispatch custom event to notify App component
    window.dispatchEvent(new CustomEvent('pwa-install-available'));
});

// Listen for app installed event
window.addEventListener('appinstalled', () => {
    console.log('PWA was installed');
    window.deferredPrompt = null;
    window.dispatchEvent(new CustomEvent('pwa-installed'));
});